export default function BookingStepper({ isComplete }) {
  const activeStyle = {
    background: 'linear-gradient(135deg, #D4AF37 0%, #F7D08F 100%)',
    color: '#1C140A',
    boxShadow: '0 6px 18px -6px rgba(212,175,55,.6)',
  }
  const idleStyle = { background: '#1C140A', color: '#fff' }
  const pendingStyle = { background: 'rgba(28,20,10,.06)', color: 'rgba(28,20,10,.35)' }

  return (
    <div className="flex items-center gap-3 sm:gap-4 mb-10">
      <div className="flex items-center gap-2.5">
        <span
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[11px] font-bold transition-all"
          style={isComplete ? activeStyle : idleStyle}
        >
          {isComplete ? (
            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
              <path strokeLinecap="round" strokeLinejoin="round" d="m5 13 4 4L19 7" />
            </svg>
          ) : '1'}
        </span>
        <span className="text-[10px] sm:text-[11px] font-bold uppercase tracking-widest text-[#1C140A]">
          Choose date &amp; time
        </span>
      </div>

      <div
        className="h-px flex-1 max-w-20 transition-colors"
        style={{ background: isComplete ? 'linear-gradient(90deg, #D4AF37, #F7D08F)' : 'rgba(200,146,42,.22)' }}
      />

      <div className="flex items-center gap-2.5">
        <span
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[11px] font-bold transition-all"
          style={isComplete ? activeStyle : pendingStyle}
        >
          2
        </span>
        <span
          className="text-[10px] sm:text-[11px] font-bold uppercase tracking-widest transition-colors"
          style={{ color: isComplete ? '#1C140A' : 'rgba(28,20,10,.35)' }}
        >
          Confirm &amp; pay
        </span>
      </div>
    </div>
  )
}
